import { useContext, useEffect, useState } from "react";
import Select from "react-dropdown-select";
import dropdownOptions from "../data/dropdownOptions.json";
import { StoreContext } from "../store/Store";
import { GlobalRefContext } from "../store/GlobalRefs";
import { actionTypes } from "../store/storeTypes";
import { appendAudit } from "./custom/audit";

// const parentStyle = {
//   width: "100%",
//   height: "100%",
//   display: "flex",
//   justifyContent: "center",
// };

export const SelectFromDropdown = ({ data }) => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const { mode } = store;
  const selectStyle = {}; //{ width: flowConfig.selectBoxWidth };
  const [options, setOptions] = useState(null);

  useEffect(() => {
    if (data.list) {
      let options = dropdownOptions[data.list];
      options = options
        ? options.sort((a, b) => {
            return a.label > b.label ? 1 : a.label < b.label ? -1 : 0;
          })
        : [];
      // options.unshift({
      //   "label": "All",
      //   "value": "All"
      // },)

      setOptions(options);
    }
  }, [data.list]);

  return options ? (
    <div style={selectStyle}>
      <Select
        options={options}
        onChange={(values) => {
          if (mode === "flow") {
            appendAudit(grefs, data.id, "select", values[0].label);
            grefs.selectRef.current = data.id;
            grefs.selectPersistedRef.current = data.id;
            grefs.selectedRef.current[data.id] = {};
            switch (data.list) {
              case "countries":
                dispatch({
                  type: actionTypes.SET_SELECTED_COUNTRY,
                  payload: values[0].value,
                });
                break;
              case "industryGroups":
                dispatch({
                  type: actionTypes.SET_MENU_SELECTION,
                  payload: values[0].value,
                });
                break;
              default: {
                console.log("default select invalid list");
              }
            }
            // dispatch({
            //   type: actionTypes.SET_MENU_SELECTION_TRIGGER,
            //   payload: Math.random(),
            // });
          }
        }}
      />
    </div>
  ) : // </div>
  null;
};
